import React, { useContext } from 'react';
import { Button, Form, Input, Select } from 'antd';
import { OrderContext } from '../../context/orderContext';

const formItemLayout = {
    labelCol: {
        xs: {
            span: 24,
        },
        sm: {
            span: 8,
        },
    },
    wrapperCol: {
        xs: {
            span: 24,
        },
        sm: {
            span: 16,
        },
    },
};
const tailFormItemLayout = {
    wrapperCol: {
        xs: {
            span: 24,
            offset: 0,
        },
        sm: {
            span: 16,
            offset: 8,
        },
    },
};
const ManagedSelfCard = ({ onClose, onFinish }) => {
    const [form] = Form.useForm();
    const { address } = useContext(OrderContext);
    const [companyAddress, setCompanyAddress] = address;

    const onFormSubmit = values => {
        // props.onFinish(values);
        const temp = {
            referenceNumber: values.referenceNumber?.trim(),
            trackingNumber: values.trackingNumber?.trim(),
        };
        if (values.src) temp.src = companyAddress.find(elm => elm._id === values.src);
        onFinish(temp);
        // handleBoxCard(temp);
        // setSelfBoxInfoFlag(false);
    };

    return (
        <div>
            {/* <h2>ManagedSelfCard</h2> */}
            <Form
                form={form}
                name="register"
                onFinish={onFormSubmit}
                initialValues={{
                    prefix: '+91',
                }}
                {...formItemLayout}
                // scrollToFirstError
            >
                <Form.Item name="src" label="From Address" className="mt-1">
                    <Select
                        className="from_address_selector address_selector"
                        placeholder="Select Address"
                        id="byClient"
                        options={companyAddress?.map(elm => {
                            return {
                                value: elm?._id,
                                label: `${elm?.alias}, ${elm?.addressLine1}, ${elm?.addressLine2}, ${elm?.city}, ${elm?.stateOrProvince}, ${elm?.country}`,
                            };
                        })}
                    />
                </Form.Item>

                <Form.Item
                    name="trackingNumber"
                    label="Tracking / AWB"
                    rules={[
                        {
                            validator: (_, value) => (value && !value.trim() ? Promise.reject(new Error('No spaces allowed')) : Promise.resolve()),
                        },
                    ]}
                    I
                >
                    <Input required />
                </Form.Item>
                <Form.Item
                    name="referenceNumber"
                    label="Reference"
                    rules={[
                        {
                            validator: (_, value) => (value && !value.trim() ? Promise.reject(new Error('No spaces allowed')) : Promise.resolve()),
                        },
                    ]}
                >
                    <Input required />
                </Form.Item>
                <Form.Item {...tailFormItemLayout}>
                    <Button type="primary" htmlType="submit">
                        ok
                    </Button>
                    <Button
                        type="default"
                        onClick={() => {
                            // setSelfBoxInfoFlag(false);
                            onClose();
                        }}
                        style={{
                            marginLeft: '10px',
                        }}
                    >
                        Cancel
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
};

export default ManagedSelfCard;
